import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AccountService } from '../shared/services';

@Component({
    templateUrl: './change-password.page.html',
    standalone: false
})
export class ChangePasswordPageComponent implements OnInit {
  isChangePasswordFailed = false;
  changePasswordForm: UntypedFormGroup;

  constructor(private router: Router, private account: AccountService) {}

  ngOnInit() {
    this.changePasswordForm = new UntypedFormGroup({
      oldPassword: new UntypedFormControl(''),
      newPassword: new UntypedFormControl(''),
      confirmPassword: new UntypedFormControl('')
    });
  }

  onSubmit(form: UntypedFormGroup) {
    this.account.changePassword(form.value).subscribe((res) => {
      this.isChangePasswordFailed = res.status !== 200 ? true : false;
      if (!this.isChangePasswordFailed) {
        this.router.navigateByUrl('/');
      }
    });
  }
}
